
export enum DataType {
    TEXT    = 'text',
    NUMBER  = 'number',
    DATE    = 'date',
    TIME    = 'time',
    DATETIME= 'datetime',
    BOOLEAN = 'boolean',
    ERROR   = 'error',
}
